import { gtb, towne, fizz } from "./companies";
import { CustomApp } from "./types";

export const companies: [RegExp, CustomApp][] = [
  [/fordevents.live$/, gtb],
  [/towne.live$/, towne],
  [/fizzevents.live$/, fizz],
];
